import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { TipoProjeto } from '../models/tipoProjeto.model';

@Injectable({
  providedIn: 'root'
})
export class TipoProjetoService extends BaseService<TipoProjeto> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/tipoProjeto`, injector);
  }
}
